import React from 'react';
import AdminDashboardV2 from './AdminDashboardV2';

// Super-admin landing page. Was a basic stats grid → became OrgConstellation
// → now AdminDashboardV2 with KPI cards + sparklines + filter chips +
// constellation + time scrubber. Same component, broader picture.
export default function AdminDashboard() {
  return <AdminDashboardV2 />;
}
